import GuideTopicsPage from "./GuideTopicsPage"

export default GuideTopicsPage
